<template>
  <div class="page-container" style="min-height: auto;">
    <header class="page-title-container">
      <a class="category-text">Category</a>
      <h1 class="title-text">{{ data.meta.name }}</h1>
      <time class="article-preview-date">{{ dateToYMD(data.meta.createdAt) }}</time>
    </header>

    <div class="center-items">
      <div class="article-container">
        <article>
          <div class="center-items" style="margin-bottom: 0rem;">
            <img class="image-hero" :src="require('@/assets/' + data.meta.imageName)" />
          </div>
          <div class="blog-article">
            <!-- Start article content -->
            <slot> </slot>
            <!-- End article content -->
          </div>
        </article>
      </div>
    </div>
  </div>

  <div class="page-container" style="min-height: auto;">
    <div class="page-title-container">
      <h1 class="title-text" style="margin-top: 0rem;">More Blog Posts</h1>
    </div>

    <div class="masonry-container">
      <div class="article-card-container" v-for="(a, i) in related" :key="`related-${i}`" @click="$router.push({ path: a.path })">
        <div class="article-card-image-container">
          <img class="image-hero" :src="require(`@/assets/blog/${a.meta.imageName}`)" />
        </div>
        <h1 class="article-card-title">{{ a.meta.name }}</h1>
      </div>
    </div>
  </div>

  <NewsletterCTA />
  <CulDeSac />
</template>

<script>
import CulDeSac from "@/components/CulDeSac";
import NewsletterCTA from "@/components/NewsletterCTA";

import blogRouter from "@/blog/blog";
import categories from "@/blog/categories";

import utils from "@/utils";

export default {
  components: {
    CulDeSac,
    NewsletterCTA,
  },

  created() {
    window.scrollTo(0, 0);
  },

  data() {
    const maxPosts = 6;
    const shuffled = utils.shuffleArray(blogRouter);
    const data = blogRouter.find((x) => x.path === this.$route.path);
    return {
      categories,
      data,
      related: shuffled.slice(0, maxPosts).filter((x) => x.meta.name !== data.meta.name),
    };
  },

  methods: {
    dateToYMD(date) {
      let strArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let m = strArray[date.getMonth()];
      let y = date.getFullYear();
      return "" + m + " " + y;
    },
  },
};
</script>

<style>
.blog-article > h3 {
  color: var(--primary-color);
}

.blog-article > img {
}
</style>
